/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import can from 'can';
import BaseWidget from 'scripts/base-widget';
import 'components/history-experience/landing/landing';

export const HistoryExperienceLanding = BaseWidget.extend({
    init() {
        this.viewModel = {
            video: new can.Map(this.options.video),
            introText: new can.Map(this.options.introText),
            cta: new can.Map(this.options.cta),
            image: new can.Map(this.options.image),
            sponsor: new can.Map(this.options.sponsor)
        };
        this.view = can.stache('<history-experience-landing {video}="video" {intro-text}="introText" {cta}="cta" {image}="image" {sponsor}="sponsor"></history-experience-landing>');
        this._super();
    },
});